<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "ProgressLine" });
import "tailwindcss/tailwind.css";
export let progress = 0;
export let mode = "light";
export let label = "";
$: validatedProgress = Math.min(100, Math.max(0, progress));
</script>

<div class = {`s8-progress-line s8-${ mode }`} role = 'progressbar'>
    <div class = 's8-background'></div>
    {#if validatedProgress > 0}
        <div class = 's8-highlight' style = '--width: { validatedProgress }%'></div>
    {/if}
    {#if label !== ''}
        <div class ='s8-label'>{ label }</div>
    {/if}
</div>

<style>
    div.s8-progress-line {
        position: relative;
        height: 25px;
    }

        div.s8-progress-line .s8-background, div.s8-progress-line .s8-highlight {
            height: 1px;
            width: 100%;
            position: absolute;
        }

        div.s8-progress-line .s8-background {
            background-color: var(--background-color);
        }

        div.s8-progress-line .s8-highlight {
            background-color: var(--highlight-color);
            box-shadow: 0 0 1px 1px var(--box-shadow-color);
            width: var(--width, 100%);
        }

        div.s8-progress-line .s8-label {
            font-size: 10px;
            line-height: 15px;
            color: #272711;
            position: absolute;
            top: 3px;
            text-align: left;
        }

        div.s8-progress-line.s8-dark {
            --background-color: rgba(31,71,48, 0.24);
            --highlight-color: rgba(255, 255, 255, 1.00);
            --box-shadow-color: rgba(255, 255, 255, 0.52);
        }

        div.s8-progress-line.s8-light {
            --background-color: rgba(39, 39, 17, 0.1);
            --highlight-color: rgba(68, 131, 95, 1.00);
            --box-shadow-color: rgba(68, 131, 95, 0.36);
        }</style>